import React from 'react';
import PropTypes from 'prop-types';

const SanitizedString = ({ rawString }) => {
  return <span dangerouslySetInnerHTML={{ __html: rawString }} />;
};

SanitizedString.propTypes = {
  rawString: PropTypes.string
};

// SanitizedString.defaultProps = {};

export default SanitizedString;
